import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import LocalizationConsumer from '../../../l10n/localization-context';

import './loader.less';

const Loader = ({ className }) =>
{
  const loaderClassnames = classnames({
    '-wa-edit-controls__loader': true,
    [className]: !!className
  });

  return (
    <div className={loaderClassnames}>
      <div className="-wa-edit-controls__loader-content">
        <LocalizationConsumer id="loader.please-wait" />
      </div>
    </div>);
};

Loader.propTypes = {
  className: PropTypes.string
};

Loader.defaultProps = {
  className: undefined
};

export default Loader;